var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRouterAlive)?_c('RouterView',{staticClass:"app",class:{'in-saas-iframe': _vm.$isInSaasIframe},attrs:{"id":"app"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }